module.exports = __webpack_public_path__ + "static/media/js.3094c423.svg";